import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { H4 } from '@finect/tabular-core/Headings';
import { scrollY } from '@finect/tabular-utils/scrollY';
export var ModalHeader = styled.div.withConfig({
  displayName: "ModalComponents__ModalHeader",
  componentId: "sc-qvc64n-0"
})(["padding:0 24px;margin-bottom:24px;h4{margin-top:16px;color:", ";}h5{", "}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.font;
}, getFont(0));
export var ModalTitle = styled(H4).withConfig({
  displayName: "ModalComponents__ModalTitle",
  componentId: "sc-qvc64n-1"
})([""]);
export var ModalSubtitle = styled.h5.withConfig({
  displayName: "ModalComponents__ModalSubtitle",
  componentId: "sc-qvc64n-2"
})([""]);
export var ModalBody = styled.div.withConfig({
  displayName: "ModalComponents__ModalBody",
  componentId: "sc-qvc64n-3"
})(["", " padding:0 24px 12px;"], scrollY);
export var ModalFooter = styled.div.withConfig({
  displayName: "ModalComponents__ModalFooter",
  componentId: "sc-qvc64n-4"
})(["display:flex;padding:18px 24px 0;border-top:1px solid ", ";", " margin-top:auto;> div{margin-left:auto;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
}, function (_ref3) {
  var _ref3$topMargin = _ref3.topMargin,
    topMargin = _ref3$topMargin === void 0 ? false : _ref3$topMargin;
  return topMargin ? 'margin-top: 36px;' : '';
});
export var ModalInner = styled.div.withConfig({
  displayName: "ModalComponents__ModalInner",
  componentId: "sc-qvc64n-5"
})(["display:flex;flex-flow:column;height:100%;padding:18px 0;", "{flex-grow:1;}"], ModalBody);